/**
 * Simple FRVR shareMessage payload for game-over score brag.
 */

/**
 * @param {{ score?: number, bestScore?: number }} params
 * @returns {{ headline: string, text: string, image: string, cta: string }}
 */
export function buildGameOverSharePayload(params) {
  var opts = params || {};
  var score = Math.max(0, Math.floor(Number(opts.score) || 0));
  var best = Math.max(score, Math.floor(Number(opts.bestScore) || 0));

  var canvas = document.createElement("canvas");
  canvas.width = 320;
  canvas.height = 180;
  var ctx = canvas.getContext("2d");
  if (ctx) {
    var gradient = ctx.createLinearGradient(0, 0, 320, 180);
    gradient.addColorStop(0, "#1b6cff");
    gradient.addColorStop(1, "#0b2d6b");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 320, 180);
    ctx.fillStyle = "#ffffff";
    ctx.textAlign = "center";
    ctx.font = "bold 28px Fredoka, system-ui, sans-serif";
    ctx.fillText("Catch'n'Merge", 160, 64);
    ctx.font = "20px Fredoka, system-ui, sans-serif";
    ctx.fillText("Score: " + String(score), 160, 108);
    ctx.fillText("Best: " + String(best), 160, 138);
  }

  var image = null;
  if (ctx && typeof canvas.toDataURL === "function") {
    try {
      image = canvas.toDataURL("image/png");
    } catch (e) {
      image = null;
    }
  }

  return {
    headline: "Catch'n'Merge",
    text: "I scored " + score + "! Can you beat my best of " + best + "?",
    image: image,
    cta: "Play now",
  };
}
